<div *ngIf="cards$ | async as cards" class="row p-3">
  <fgb-card-list-item class="col-12 col-md-4 mb-2" *ngFor="let card of cards" [card]="card"></fgb-card-list-item>
</div>
